// extracted by mini-css-extract-plugin
var _1 = "CompanyHeaderStyles-module__bordered___H1ESr";
var _2 = "CompanyHeaderStyles-module__header___zYUJd";
var _3 = "CompanyHeaderStyles-module__header-edit___tFUMi";
var _4 = "CompanyHeaderStyles-module__header-edit_headline___EFKp4";
var _5 = "CompanyHeaderStyles-module__header-edit_logo___bMO5O";
var _6 = "CompanyHeaderStyles-module__header-edit___tFUMi";
var _7 = "CompanyHeaderStyles-module__header-edit_headline___EFKp4";
var _8 = "CompanyHeaderStyles-module__header-edit_logo___bMO5O";
var _9 = "CompanyHeaderStyles-module__header_logo___Bj1kl";
var _a = "CompanyHeaderStyles-module__header_logo___Bj1kl";
var _b = "CompanyHeaderStyles-module__legal-name___LfJj5";
var _c = "CompanyHeaderStyles-module__legal-name___LfJj5";
var _d = "CompanyHeaderStyles-module__remove-avatar___U4mfU";
var _e = "CompanyHeaderStyles-module__remove-avatar___U4mfU";
var _f = "CompanyHeaderStyles-module__right___ILppP";
export { _1 as "bordered", _2 as "header", _3 as "header-edit", _4 as "header-edit_headline", _5 as "header-edit_logo", _6 as "headerEdit", _7 as "headerEditHeadline", _8 as "headerEditLogo", _9 as "headerLogo", _a as "header_logo", _b as "legal-name", _c as "legalName", _d as "remove-avatar", _e as "removeAvatar", _f as "right" }
